module.exports = __webpack_public_path__ + "img/Small-Semi-Elliptical-Attachment-L-15.7a7232f2.png";